import { IFilterListaNegraModel } from "../interfaces/listanegra/IFilterListaNegraModel";

export class FilterListaNegraModel implements IFilterListaNegraModel{    
    nombres: string;
    nroDocumento: string;
    idsListaNegra: number[];
    page: number;
    pageSize: number;
    companias: number[];

    constructor(){
        this.nombres = '';
        this.nroDocumento = '';
        this.idsListaNegra = new Array<number>();
        this.page = 1;
        this.pageSize = 30;
        this.companias = []
    }
}